export const DIALOG_BREAKDOWN = 840;
